import React from 'react';

import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {Optional} from 'util/Types';

export const NO_VALUE_TOOLTIP_TITLE = 'No value';

interface TableCellWithTooltipProps {
  className?: string;
  children: React.ReactNode;
  tooltipTitle: Optional<string>;
}

export default function TableCellWithTooltip({
  className,
  children,
  tooltipTitle,
}: TableCellWithTooltipProps): JSX.Element {
  return (
    <Tooltip text={tooltipTitle} placement={FloatingPlacement.TOP} disableContentSelection={true}>
      {
        // We need a wrapper `div` here because Tooltip can only have one child node, otherwise it won't
        // be properly destroyed
      }
      <div className={className}>{children}</div>
    </Tooltip>
  );
}
